import { render, staticRenderFns } from "./liulan.vue?vue&type=template&id=efa3f532&scoped=true&"
import script from "./liulan.vue?vue&type=script&lang=js&"
export * from "./liulan.vue?vue&type=script&lang=js&"
import style0 from "./liulan.vue?vue&type=style&index=0&id=efa3f532&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3f532",
  null
  
)

export default component.exports